import {SerializedError} from '@reduxjs/toolkit'
import {FetchBaseQueryError} from '@reduxjs/toolkit/query'
import {Error, ResponseError} from './_models'
import {ErrorApis} from './enums'

export const getRTKError = (err: FetchBaseQueryError | SerializedError | any): Error => {
  if (!err) return {title: undefined, description: undefined}
  var error: any

  if (err.error) {
    error = err.error
  } else {
    error = err
  }

  if (typeof error === 'string') return {title: undefined, description: error}

  if ('status' in error) {
    if (error.status === 'FETCH_ERROR')
      return {title: undefined, description: ErrorApis.ErrorConnection}

    return {
      title: (error.data as ResponseError)?.info.title,
      description: (error.data as ResponseError)?.info.message,
    }
  }
  return {title: undefined, description: ErrorApis.Generic500}
}

export const getLink = (data: string) => {
  if (!data) return
  const uint8Array = new Uint8Array(JSON.parse(data))
  const blob = new Blob([uint8Array], {type: 'application/octet-stream'})
  const url = window.URL.createObjectURL(new Blob([blob]))
  return url//
}